export const noticePath = '/notice'
export const systemRedirectPath = '/system/redirect'
export const loginPath = '/login'
export const loginParameterPath = '/:login'
export const mailStatisticPath = '/mailstat'
export const mailStatisticParameterPath = '/:mailstat'
